const NUMBER_FORMATTER = new Intl.NumberFormat('en-GB');

export function formatCoveragePercent(value: number | undefined | null): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) {
    return '--';
  }
  return `${value.toFixed(1)}%`;
}

export function formatCount(value: number | undefined | null): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '--';
  }
  return NUMBER_FORMATTER.format(value);
}

export function formatLengthKm(value: number | undefined | null): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) {
    return '--';
  }
  return `${NUMBER_FORMATTER.format(Math.round(value * 10) / 10)} km`;
}

export function buildSurveyCoverageHelperText(
  filter: {
    readonly surveyType?: string;
    readonly surveyYear?: string;
    readonly lane?: string;
  },
): string {
  if (!filter.surveyType) {
    return 'Select a survey type to see coverage';
  }

  if (!filter.surveyYear) {
    return `Select a survey year to see ${humanizeSlug(filter.surveyType)} coverage`;
  }

  const parts = [humanizeSlug(filter.surveyType), filter.surveyYear];
  if (filter.lane) {
    parts.push(filter.lane.toUpperCase());
  }

  return `Coverage for ${parts.join(' · ')}`;
}

export function humanizeSlug(slug: string): string {
  if (!slug) return '';
  return slug
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
    .join(' ');
}
